import createSculptSmoothStore from './createSculptSmoothStore';

/**
 * Sculpt Smooth brush state for the **Rectification** step.
 *
 * One instance per step that exposes the brush, so an apply on one step does not
 * read as applied on another — the same reason Inflate / Deflate has its own
 * per-step store. See `createSculptBrushStore`.
 */
const useRectificationSculptSmoothStore = createSculptSmoothStore({
  name: 'rectification-sculpt-smooth-store',
});

export default useRectificationSculptSmoothStore;
